export const COIN = "HEXDC";
export const GT = "FLEX";
export const LP = "LP";
// export const LP = "ETH/LUSD LP";
